(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cookie-consent"] && !Shopify.designMode) return;
  try {
    (function() {
      const banner = document.querySelector('[data-cookie-banner]');
      const modal = document.querySelector('[data-cookie-modal]');
      if (!banner) return;

      const STORAGE_KEY = banner.dataset.storageKey || 'cc_cookie_prefs_v1';
      const TOGGLES = Array.from(document.querySelectorAll('[data-cookie-toggle]'));
      const CATEGORIES = ['analytics', 'marketing', 'personalization'];

      function readPrefs() {
        try {
          const raw = localStorage.getItem(STORAGE_KEY);
          return raw ? JSON.parse(raw) : null;
        } catch {
          return null;
        }
      }

      function writePrefs(prefs) {
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...prefs, ts: Date.now() }));
        } catch {}
        document.dispatchEvent(new CustomEvent('cookieconsent:change', { detail: prefs }));
      }

      function showBanner() {
        banner.hidden = false;
        requestAnimationFrame(() => banner.setAttribute('data-state', 'visible'));
      }

      function hideBanner() {
        banner.removeAttribute('data-state');
        setTimeout(() => { banner.hidden = true; }, 380);
      }

      function openModal() {
        if (!modal) return;
        const prefs = readPrefs() || {};
        TOGGLES.forEach((t) => {
          const key = t.dataset.cookieToggle;
          t.checked = !!prefs[key];
        });
        modal.hidden = false;
        const firstFocus = modal.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (firstFocus) firstFocus.focus();
        document.body.style.overflow = 'hidden';
      }

      function closeModal() {
        if (!modal) return;
        modal.hidden = true;
        document.body.style.overflow = '';
      }

      function acceptAll() {
        const prefs = { essential: true };
        CATEGORIES.forEach((c) => { prefs[c] = true; });
        writePrefs(prefs);
        hideBanner();
        closeModal();
      }

      function rejectAll() {
        const prefs = { essential: true };
        CATEGORIES.forEach((c) => { prefs[c] = false; });
        writePrefs(prefs);
        hideBanner();
        closeModal();
      }

      function savePrefs() {
        const prefs = { essential: true };
        TOGGLES.forEach((t) => { prefs[t.dataset.cookieToggle] = t.checked; });
        writePrefs(prefs);
        hideBanner();
        closeModal();
      }

      document.querySelectorAll('[data-cookie-action]').forEach((el) => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          const action = el.dataset.cookieAction;
          if (action === 'accept') acceptAll();
          else if (action === 'reject') rejectAll();
          else if (action === 'save') savePrefs();
          else if (action === 'manage') openModal();
          else if (action === 'close-modal') closeModal();
        });
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
      });

      window.openCookiePreferences = openModal;
      document.querySelectorAll('[data-open-cookie-prefs]').forEach((el) => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          openModal();
        });
      });

      if (!readPrefs()) showBanner();
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fomo-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.getElementById('fomo-popup');
    var dataEl = document.getElementById('fomo-popup-data');
    if (!root || !dataEl) return;

    var DISMISS_KEY = 'bw-fomo-dismissed';
    try {
      if (sessionStorage.getItem(DISMISS_KEY)) return;
    } catch (e) {
      /* storage unavailable — keep showing popups */
    }

    var orders;
    try {
      orders = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var maxAgeMs = parseInt(root.dataset.maxAgeHours, 10) * 60 * 60 * 1000;
    var now = Date.now();
    orders = orders
      .map(function (o) {
        o.timestamp = Date.parse(o.at);
        return o;
      })
      .filter(function (o) {
        return !isNaN(o.timestamp) && now - o.timestamp <= maxAgeMs;
      })
      .sort(function (a, b) {
        return b.timestamp - a.timestamp;
      });
    if (!orders.length) return;

    var initialDelay = parseInt(root.dataset.initialDelay, 10) * 1000;
    var displayDuration = parseInt(root.dataset.displayDuration, 10) * 1000;
    var interval = parseInt(root.dataset.interval, 10) * 1000;

    var link = document.getElementById('fomo-popup-link');
    var image = document.getElementById('fomo-popup-image');
    var buyer = document.getElementById('fomo-popup-buyer');
    var product = document.getElementById('fomo-popup-product');
    var time = document.getElementById('fomo-popup-time');
    var compact = document.getElementById('fomo-popup-compact');
    var index = 0;
    var hideTimer;
    var dismissed = false;

    /* Minutes, then hours — never days. Anything old enough to be measured in
       days has already been filtered out, and rounding down keeps the claim
       conservative (a 119-minute-old order reads "1 hour ago", not "2 hours"). */
    function timeAgo(timestamp) {
      var mins = Math.floor((Date.now() - timestamp) / 60000);
      if (mins < 2) return 'just now';
      if (mins < 60) return mins + ' minutes ago';
      var hours = Math.floor(mins / 60);
      return hours + (hours === 1 ? ' hour ago' : ' hours ago');
    }

    function show() {
      if (dismissed) return;
      var order = orders[index % orders.length];
      index += 1;

      link.href = order.url;
      image.src = order.image || '';
      image.alt = order.title;
      buyer.textContent = order.city
        ? order.name + ' from ' + order.city + ' purchased'
        : order.name + ' purchased';
      product.textContent = order.title;
      time.textContent = timeAgo(order.timestamp);
      if (compact) {
        compact.textContent =
          (order.city ? order.name + ', ' + order.city : order.name) +
          ' · ' + timeAgo(order.timestamp);
      }

      root.hidden = false;
      requestAnimationFrame(function () {
        root.classList.add('is-visible');
      });
      hideTimer = setTimeout(hide, displayDuration);
      setTimeout(show, displayDuration + interval);
    }

    function hide() {
      root.classList.remove('is-visible');
    }

    document.getElementById('fomo-popup-close').addEventListener('click', function () {
      dismissed = true;
      clearTimeout(hideTimer);
      hide();
      try {
        sessionStorage.setItem(DISMISS_KEY, '1');
      } catch (e) {
        /* ignore */
      }
      setTimeout(function () {
        root.remove();
      }, 400);
    });

    setTimeout(show, initialDelay);
  })();
  } catch(e) { console.error(e); }
})();

})();
